export default __webpack_public_path__ + "static/date-label-dont-3-light-75c8b8bc52e9f420ef990589bdbf8ae2.png";